<template>
  <div class="template-base" :class="{ 'menu-opened': menu }">
    <sidebar-menu v-model="menu" />
    <section class="flex-fill position-relative">
      <base-header @toggle-menu="menu = !menu" />
      <main>
        <div class="container-xxl p-0">
          <slot v-if="!loading" />
          <div v-else class="text-center p-9">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
          </div>
        </div>
      </main>
      <footer>
        © 2025 Velora
        <div class="d-flex align-items-center gap-4">
          <a href="">FAQ</a>
          <a href="">Contato</a>
        </div>
      </footer>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

import BaseHeader from "@/components/layout/BaseHeader";
import SidebarMenu from "@/components/layout/SidebarMenu";
export default {
  components: {
    SidebarMenu,
    BaseHeader
  },
  data() {
    return {
      // menu: window.innerWidth > 991
      menu: false
    };
  },
  computed: {
    ...mapState(["loading"])
  }
};
</script>

<style lang="scss">
.template-base {
  min-height: 100vh;
  display: flex;
  position: relative;

  --sidebar-width: 80px;
  @media screen and (max-width: 991px) {
    --sidebar-width: 0;
  }
  &.menu-opened {
    --sidebar-width: 250px;
  }

  footer {
    width: 100vw;
    height: var(--footer-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 28px;
    font-size: 12px;
    color: var(--dark-40);
    a {
      color: var(--dark-40);
      &:hover {
        color: var(--dark-80);
      }
    }
  }

  main {
    width: 100vw;
    padding: 28px 80px;
    position: relative;
    margin-top: var(--header-height);
    min-height: calc(100vh - var(--header-height) - var(--footer-height));
    @media screen and (max-width: 992px) {
      padding: 16px 16px;
    }
  }
  header,
  main,
  footer {
    transition: 0.4s all;
    @media screen and (min-width: 992px) {
      width: calc(100vw - var(--sidebar-width));
      margin-left: var(--sidebar-width);
    }
  }

  .profile-dropdown-wrapper {
    position: absolute;
    top: 0%;
    right: 1%;
    z-index: 1;
  }

  .dropdown-toggle-no-caret,
  .avatar-perfil {
    padding: 0;
  }

  .nav-item {
    @media screen and (max-width: 991px) {
      flex: 1;
      text-align: center;
    }
    a {
      padding: 12px;
      &.active,
      &:hover {
        font-size: 14px;
      }
    }
  }
}
</style>
